import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(landing)/template.tsx");
